/* eslint-disable @typescript-eslint/no-explicit-any */
import { GUILD_MESSAGE, NOTIFICATION_MESSAGE } from 'i18n/constants'
import ReactPaginate from 'react-paginate'
import { useTranslation } from 'react-i18next'

import { ListContainer } from './styled'
import { RankingDonate } from 'models/ranking'
import RankingItem from '../RankingItem'
import RankInfo from '../RankInfo'

const TopGuildList = ({ data, handlePageClick, pageCount, paramsSearch, numberUser, myRankingData }: any) => {
  const { t } = useTranslation()

  return (
    <ListContainer>
      <div className='my-horse-container'>
        <div className='d-flex header-horse text-uppercase'>
          <span className='width-20 center'>{t(`${NOTIFICATION_MESSAGE}.rank`)}</span>
          <span className='width-20'>{t(`${NOTIFICATION_MESSAGE}.owner`)}</span>
          <span className='width-10'>{t(`${GUILD_MESSAGE}.nft`)}</span>
          <span className='width-10'>{t(`${GUILD_MESSAGE}.nftTicket`)}</span>
          <span className='width-10'>{t(`${GUILD_MESSAGE}.adil`)}</span>
          <span className='width-10'>{t(`${GUILD_MESSAGE}.kuda`)}</span>
          <span className='width-10'>{t(`${GUILD_MESSAGE}.merah`)}</span>
          <span className='width-10'>{t(`${GUILD_MESSAGE}.nonNft`)}</span>
        </div>
        <div className='table-content'>
          <table className='my-horse-table'>
            {data?.length === 0 ? (
              <span className='no_horse_record'>
                <span className='color-white font-size-24'>No data found</span>
              </span>
            ) : (
              ''
            )}
            {data?.length > 0 && (
              <tbody>
                {data?.map((ranking: RankingDonate) => {
                  return <RankingItem key={ranking.user_id} ranking={ranking} />
                })}
              </tbody>
            )}
          </table>
          {data.length > 0 && (
            <div className='ranking-info-item' style={{ position: data.length < 7 ? 'absolute' : 'unset' }}>
              <RankInfo data={myRankingData} />
            </div>
          )}
        </div>
        {data.length > 0 && (
          <div className='paginate custom'>
            {parseInt(numberUser) > 10 && (
              <ReactPaginate
                nextLabel='>'
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel='<'
                pageClassName='page-item'
                pageLinkClassName='page-link'
                previousClassName='page-item'
                previousLinkClassName='page-link'
                nextClassName='page-item'
                nextLinkClassName='page-link'
                breakLabel='...'
                breakClassName='page-item'
                breakLinkClassName='page-link'
                containerClassName='pagination'
                activeClassName='active'
                forcePage={paramsSearch.page ? +paramsSearch.page - 1 : 0}
              />
            )}
          </div>
        )}
      </div>
    </ListContainer>
  )
}

export default TopGuildList
